import type { ViewMode, ViewerModel } from '@wix/thunderbolt-symbols'
import type { EnvironmentServiceEditorConfig, EnvironmentServiceSiteConfig } from './types'
import type { IEnvironmentServiceConfig } from '@wix/viewer-service-environment/definition'

export const getServiceConfig = (
	featureConfig: EnvironmentServiceSiteConfig | EnvironmentServiceEditorConfig,
	viewerModel: ViewerModel,
	siteLanguage: string,
	viewMode: ViewMode
): IEnvironmentServiceConfig => {
	const { localesInfo: _localesInfo, ...environmentFeatureConfig } = featureConfig

	return {
		...environmentFeatureConfig,
		editorType: featureConfig.editorType as IEnvironmentServiceConfig['editorType'],
		requestUrl: viewerModel?.requestUrl,
		isQaMode: viewerModel?.mode.qa,
		viewMode,
		editorName: viewerModel?.site.editorName,
		deviceType: viewerModel?.deviceInfo.deviceClass,
		language: siteLanguage as IEnvironmentServiceConfig['language'],
	}
}
